// Google Pay Configuration
export const googlePayConfig = {
  // Environment: 'TEST' or 'PRODUCTION'
  environment: 'TEST',
  
  // Your Google Pay Merchant ID (get from Google Pay Console)
  merchantId: '12345678901234567890',
  
  // Merchant Information
  merchantInfo: {
    merchantName: 'Organic Greens Hub',
    merchantId: '12345678901234567890'
  },
  
  // UPI Configuration
  upi: {
    payeeVpa: 'merchant@upi', // Your UPI ID
    payeeName: 'Organic Greens Hub',
    mcc: '5411' // Merchant Category Code (5411 = Grocery stores)
  },
  
  // Supported Payment Methods
  allowedPaymentMethods: [
    {
      type: 'UPI',
      parameters: {
        // Will be populated dynamically
      },
      tokenizationSpecification: {
        type: 'DIRECT'
      }
    }
  ],
  
  // Transaction Configuration
  transactionInfo: {
    totalPriceStatus: 'FINAL',
    currencyCode: 'INR',
    countryCode: 'IN'
  }
};

// Environment-specific configurations
export const environments = {
  TEST: {
    environment: 'TEST',
    merchantId: '12345678901234567890', // Test merchant ID
    upiId: 'test@upi'
  },
  PRODUCTION: {
    environment: 'PRODUCTION',
    merchantId: 'YOUR_PRODUCTION_MERCHANT_ID', // Replace with your production merchant ID
    upiId: 'your-business@upi' // Replace with your actual UPI ID
  }
};

// Get configuration based on environment
export const getGooglePayConfig = (env = 'TEST') => {
  const envConfig = environments[env];
  return {
    ...googlePayConfig,
    environment: envConfig.environment,
    merchantInfo: {
      ...googlePayConfig.merchantInfo,
      merchantId: envConfig.merchantId
    },
    upi: {
      ...googlePayConfig.upi,
      payeeVpa: envConfig.upiId
    }
  };
};